// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"d8c815c0","419":"2ab9aec5","480":"c93b9948","563":"20748574","785":"ef9fcf69","787":"3aa6e63a","866":"e0ebccf3","883":"0601e444","940":"6383135f","974":"235fa394"}[chunkId] + ".chunk.js";
};